export const SET_FILTER_TYPE = "SET_FILTER_TYPE";
export const CHANGE_OVERVIEW_MODALS = "CHANGE_OVERVIEW_MODALS";

export const SET_ACTIVE_RANGE_TYPE = "SET_ACTIVE_RANGE_TYPE";
export const RESET_ACTIVE_RANGE_TYPE = "RESET_ACTIVE_RANGE_TYPE";

export const REQUEST_RESPONSE_DATA = "REQUEST_RESPONSE_DATA";
export const SET_RESPONSE_DATA = "SET_RESPONSE_DATA";
export const REVOKE_RESPONSE_DATA = "REVOKE_RESPONSE_DATA";
export const RESET_RESPONSE_DATA = "RESET_RESPONSE_DATA";

export const REQUEST_CLIENT_MAP_DATA = "REQUEST_CLIENT_MAP_DATA";
export const SET_CLIENT_MAP_DATA = "SET_CLIENT_MAP_DATA";
export const REVOKE_CLIENT_MAP_DATA = "REVOKE_CLIENT_MAP_DATA";
export const RESET_CLIENT_MAP_DATA = "RESET_CLIENT_MAP_DATA";

export const REQUEST_SALES_DATA = "REQUEST_SALES_DATA";
export const SET_SALES_DATA = "SET_SALES_DATA";
export const REVOKE_SALES_DATA = "REVOKE_SALES_DATA";
export const RESET_SALES_DATA = "RESET_SALES_DATA";

export const REQUEST_CLIENTS_DATA = "REQUEST_CLIENTS_DATA";
export const SET_CLIENTS_DATA = "SET_CLIENTS_DATA";
export const REVOKE_CLIENTS_DATA = "REVOKE_CLIENTS_DATA";
export const RESET_CLIENTS_DATA = "RESET_CLIENTS_DATA";

export const REQUEST_DELIVERIES_DATA = "REQUEST_DELIVERIES_DATA";
export const SET_DELIVERIES_DATA = "SET_DELIVERIES_DATA";
export const REVOKE_DELIVERIES_DATA = "REVOKE_DELIVERIES_DATA";
export const RESET_DELIVERIES_DATA = "RESET_DELIVERIES_DATA";

export const REQUEST_SELECTION_YEARS = "REQUEST_SELECTION_YEARS";
export const SET_SELECTION_YEARS = "SET_SELECTION_YEARS";
export const REVOKE_SELECTION_YEARS = "REVOKE_SELECTION_YEARS";
export const RESET_SELECTION_YEARS = "RESET_SELECTION_YEARS";

export const SET_ACTIVE_SELECTION_YEAR = "SET_ACTIVE_SELECTION_YEAR";
export const RESET_ACTIVE_SELECTION_YEAR = "RESET_ACTIVE_SELECTION_YEAR";

export const REQUEST_REVENUE_DATA = "REQUEST_REVENUE_DATA";
export const SET_REVENUE_DATA = "SET_REVENUE_DATA";
export const REVOKE_REVENUE_DATA = "REVOKE_REVENUE_DATA";
export const RESET_REVENUE_DATA = "RESET_REVENUE_DATA";

export const REQUEST_GOAL_DATA = "REQUEST_GOAL_DATA";
export const SET_GOAL_DATA = "SET_GOAL_DATA";
export const REVOKE_GOAL_DATA = "REVOKE_GOAL_DATA";
export const RESET_GOAL_DATA = "RESET_GOAL_DATA";

export const SET_GOAL_TYPE = "SET_GOAL_TYPE";
export const RESET_GOAL_TYPE = "RESET_GOAL_TYPE";

export const REQUEST_CREATE_NEW_GOAL = "REQUEST_CREATE_NEW_GOAL";
export const GRANT_CREATE_NEW_GOAL = "GRANT_CREATE_NEW_GOAL";
export const REVOKE_CREATE_NEW_GOAL = "REVOKE_CREATE_NEW_GOAL";
export const RESET_CREATE_NEW_GOAL = "RESET_CREATE_NEW_GOAL";

export const REQUEST_DELETE_SINGLE_GOAL = "REQUEST_DELETE_SINGLE_GOAL";
export const REVOKE_DELETE_SINGLE_GOAL = "REVOKE_DELETE_SINGLE_GOAL";
export const RESET_DELETE_SINGLE_GOAL = "RESET_DELETE_SINGLE_GOAL";
export const GRANT_DELETE_SINGLE_GOAL = "GRANT_DELETE_SINGLE_GOAL";

export const REQUEST_UPDATE_SINGLE_GOAL = "REQUEST_UPDATE_SINGLE_GOAL";
export const REVOKE_UPDATE_SINGLE_GOAL = "REVOKE_UPDATE_SINGLE_GOAL";
export const RESET_UPDATE_SINGLE_GOAL = "RESET_UPDATE_SINGLE_GOAL";
export const GRANT_UPDATE_SINGLE_GOAL = "GRANT_UPDATE_SINGLE_GOAL";

export const SET_ACTIVE_UPDATE_GOAL = "SET_ACTIVE_UPDATE_GOAL";
export const RESET_ACTIVE_UPDATE_GOAL = "RESET_ACTIVE_UPDATE_GOAL";
